/**
  * 举报 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const report = {
    // 列表
    list(params) {
        return axios.get(api + 'report/list', { params: params })
    },
    //获取编辑信息
    remove(params) {
        return axios.post(api + 'report/remove', qs.stringify(params));
    },
}


// 导出接口
export default report